(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barry-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.bfaq__item') : null;
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barry-product-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pfReady === '1') return;
      root.dataset.pfReady = '1';

      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pf-panel]'));
      if (!panels.length) return;

      var byId = {};
      panels.forEach(function (p) { byId[p.dataset.pfPanel] = p; });

      var rootId = root.dataset.pfRoot;
      if (!byId[rootId]) rootId = panels[0].dataset.pfPanel;

      var nav = root.querySelector('[data-pf-nav]');
      var trail = root.querySelector('[data-pf-trail]');
      var back = root.querySelector('[data-pf-back]');
      var progress = root.querySelector('[data-pf-progress]');
      var progressBar = root.querySelector('[data-pf-progress-bar]');
      var progressText = root.querySelector('[data-pf-progress-text]');
      var share = root.querySelector('[data-pf-share]');
      var restart = root.querySelector('[data-pf-restart]');
      var canShare = !!(navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext);

      root.classList.add('pf--js');
      if (progress) progress.hidden = false;

      function chain(id) {
        var out = [];
        var p = byId[id];
        var guard = 0;
        while (p && guard < 10) {
          out.unshift(p);
          p = p.dataset.pfParent ? byId[p.dataset.pfParent] : null;
          guard++;
        }
        return out;
      }

      function show(id, opts) {
        opts = opts || {};
        var target = byId[id] ? id : rootId;
        var panel = byId[target];

        panels.forEach(function (p) {
          p.hidden = p.dataset.pfPanel !== target;
          if (p.hidden) p.removeAttribute('data-pf-current'); else p.setAttribute('data-pf-current', '');
        });

        var path = chain(target);

        if (trail) {
          trail.innerHTML = '';
          path.forEach(function (p, i) {
            var isLast = i === path.length - 1;
            var li = document.createElement('li');
            var el = document.createElement(isLast ? 'span' : 'button');
            el.className = 'pf__crumb' + (isLast ? ' is-current' : '');
            el.textContent = p.dataset.pfLabel || '';
            if (isLast) {
              el.setAttribute('aria-current', 'step');
            } else {
              el.type = 'button';
              el.dataset.pfGo = p.dataset.pfPanel;
            }
            li.appendChild(el);
            trail.appendChild(li);
          });
        }

        if (nav) nav.hidden = target === rootId;
        if (restart) restart.hidden = path.length < 3;
        if (back) back.dataset.pfGo = path.length > 1 ? path[path.length - 2].dataset.pfPanel : rootId;
        if (share) {
          share.hidden = !(canShare && target !== rootId);
          if (share.resetLabel) share.resetLabel();
        }

        var step = path.length;
        var total = parseInt(panel.dataset.pfTotal, 10) || step;
        if (total < step) total = step;
        if (progress) {
          progress.setAttribute('aria-valuemax', String(total));
          progress.setAttribute('aria-valuenow', String(step));
          if (progressBar) progressBar.style.width = (step / total * 100) + '%';
          if (progressText) progressText.textContent = step + ' / ' + total;
        }

        if (opts.push !== false && window.history && history.pushState) {
          try {
            var url = target === rootId ? location.pathname + location.search : '#' + target;
            // searchParams : conservé pour que facets.js (filtres Dawn/Trade) ignore cet état d'historique
            history.pushState({ pf: target, searchParams: location.search.slice(1) }, '', url);
          } catch (e) { /* silencieux */ }
        }

        if (opts.focus !== false) {
          var q = panel.querySelector('[data-pf-question]');
          if (q) {
            q.setAttribute('tabindex', '-1');
            try { q.focus({ preventScroll: true }); } catch (e) { q.focus(); }
          }
        }

        if (opts.scroll !== false) {
          var top = root.getBoundingClientRect().top;
          if (top < 0 || top > window.innerHeight * 0.6) {
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }

      root.addEventListener('click', function (e) {
        var go = e.target.closest ? e.target.closest('[data-pf-go]') : null;
        if (!go || !root.contains(go)) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        if (!byId[go.dataset.pfGo]) return;
        e.preventDefault();
        show(go.dataset.pfGo);
      });

      if (share) {
        var shareLabel = share.querySelector('[data-pf-share-label]');
        var shareDefault = shareLabel ? shareLabel.textContent : '';
        var shareTimer = null;
        share.resetLabel = function () {
          clearTimeout(shareTimer);
          share.classList.remove('is-copied');
          if (shareLabel) shareLabel.textContent = shareDefault;
        };
        share.addEventListener('click', function () {
          if (!canShare) return;
          navigator.clipboard.writeText(location.href).then(function () {
            share.classList.add('is-copied');
            if (shareLabel) shareLabel.textContent = share.dataset.pfCopied || shareDefault;
            clearTimeout(shareTimer);
            shareTimer = setTimeout(function () {
              share.classList.remove('is-copied');
              if (shareLabel) shareLabel.textContent = shareDefault;
            }, 2200);
          }).catch(function () { /* silencieux */ });
        });
      }

      window.addEventListener('popstate', function (e) {
        var id = (e.state && e.state.pf) || (location.hash ? location.hash.slice(1) : rootId);
        if (byId[id] || id === rootId) show(id, { push: false, focus: false, scroll: false });
      });

      window.addEventListener('hashchange', function () {
        var id = location.hash ? location.hash.slice(1) : rootId;
        if (byId[id] && !byId[id].hidden) return;
        if (byId[id] || id === rootId) show(id, { push: false, focus: false, scroll: false });
      });

      var initial = location.hash ? location.hash.slice(1) : rootId;
      var deep = !!byId[initial] && initial !== rootId;
      show(deep ? initial : rootId, { push: false, focus: false, scroll: deep });

      root.pfShow = show;
      initCode(root);
      initLoad(root);
    }

    // Filtre par charge : la charge saisie (lb ou kg) est comparée à la capacité (CMU, lb) de chaque
    // sous-option. Les options insuffisantes s'estompent, la plus petite option suffisante est signalée,
    // et chaque option affiche la part de sa CMU qui serait utilisée. Indication seulement ; rien n'est conservé.
    function initLoad(root) {
      var forms = root.querySelectorAll('[data-pf-load]');
      Array.prototype.forEach.call(forms, function (form) {
        var panel = form.closest('[data-pf-panel]');
        var input = form.querySelector('[data-pf-load-input]');
        var units = form.querySelectorAll('[data-pf-load-unit]');
        if (!panel || !input) return;
        var items = Array.prototype.slice.call(panel.querySelectorAll('[data-pf-cap]'));
        if (!items.length) return;
        form.hidden = false;

        function unit() {
          for (var i = 0; i < units.length; i++) if (units[i].checked) return units[i].value;
          return 'lb';
        }

        function apply() {
          var raw = parseFloat(input.value);
          var lb = isFinite(raw) && raw > 0 ? (unit() === 'kg' ? raw * 2.20462 : raw) : 0;
          var best = null;
          items.forEach(function (li) {
            var cap = parseFloat(li.dataset.pfCap) || 0;
            var tag = li.querySelector('[data-pf-fit-text]');
            li.classList.remove('is-under', 'is-best');
            if (!lb || !cap) { if (tag) { tag.hidden = true; tag.textContent = ''; } return; }
            var pct = Math.round(lb / cap * 100);
            if (lb > cap) {
              li.classList.add('is-under');
              if (tag) { tag.textContent = form.dataset.pfUnder || ''; tag.hidden = !tag.textContent; }
            } else {
              if (!best || cap < best.cap) best = { li: li, cap: cap };
              if (tag) { tag.textContent = pct + ' % ' + (form.dataset.pfUse || ''); tag.hidden = false; }
            }
          });
          if (best) {
            best.li.classList.add('is-best');
            var t = best.li.querySelector('[data-pf-fit-text]');
            if (t && form.dataset.pfFit) t.textContent = form.dataset.pfFit + ' — ' + t.textContent;
          }
        }

        input.addEventListener('input', apply);
        Array.prototype.forEach.call(units, function (u) { u.addEventListener('change', apply); });
      });
    }

    // Champ « code de produit » : un code (un seul mot) est envoyé en syntaxe « code AND code », ce qui
    // désactive l'élargissement sémantique de la recherche Shopify (produits hors sujet). Si la recherche
    // prédictive ne renvoie qu'un seul produit, on atterrit directement sur sa fiche. Sans réponse en
    // 1,5 s, la recherche classique prend le relais. Aucune donnée n'est conservée.
    function initCode(root) {
      var form = root.querySelector('[data-pf-code]');
      if (!form) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      window.addEventListener('pageshow', function () {
        form.dataset.pfBusy = '';
        form.classList.remove('is-busy');
      });

      form.addEventListener('submit', function (e) {
        var raw = (input.value || '').trim();
        if (!raw || /\s/.test(raw)) return; // plusieurs mots : recherche classique
        var code = raw.toLowerCase();
        var q = code + ' AND ' + code;
        // Le champ visible garde le code tel que saisi ; la syntaxe exacte n'apparaît que dans l'adresse envoyée.
        var exactUrl = form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
        if (form.dataset.pfBusy === '1') { e.preventDefault(); return; }
        e.preventDefault();
        var predictive = form.dataset.pfPredictive || '';
        if (!predictive || !window.fetch || !window.AbortController) { location.assign(exactUrl); return; }

        form.dataset.pfBusy = '1';
        form.classList.add('is-busy');
        var ctrl = new AbortController();
        var done = false;
        var finish = function (url) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          location.assign(url || exactUrl);
        };
        var timer = setTimeout(function () { ctrl.abort(); finish(null); }, 1500);
        var params = 'q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=2&resources[options][unavailable_products]=hide';
        fetch(predictive + '?' + params, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            var products = j && j.resources && j.resources.results && j.resources.results.products;
            finish(products && products.length === 1 && products[0].url ? products[0].url : null);
          })
          .catch(function () { finish(null); });
      });
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-pf]');
      Array.prototype.forEach.call(nodes, init);
    }

    initAll();

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('[data-pf]') : null;
      if (!root || !root.pfShow) return;
      var own = e.target.dataset.pfOwn || (e.target.closest('[data-pf-panel]') || {}).dataset;
      var id = typeof own === 'string' ? own : own && own.pfPanel;
      if (id) root.pfShow(id, { push: false, focus: false, scroll: false });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
